import { ChargeType } from "../data/entities";

export const getChargeLabel = (chargeType: ChargeType | string | undefined | null): string => {
  if (chargeType === ChargeType.Hold) return "On Hold";
  return "Due Now";
};

export const clearBookingStorage = () => {
  localStorage.removeItem("activeBookingId");
  localStorage.removeItem("activeBookingAnyProviderFlags");
  localStorage.removeItem("activeBookingInvoiceId");
};

const CUSTOMER_INFO_KEY = "customerBookingInfo";

export interface SavedCustomerBookingInfo {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  sendConfirmationToPhone?: boolean;
}

export const saveCustomerBookingInfo = (info: SavedCustomerBookingInfo) => {
  try {
    localStorage.setItem(CUSTOMER_INFO_KEY, JSON.stringify(info));
  } catch {
    // ignore storage errors (private mode, quota, etc.)
  }
};

export const loadCustomerBookingInfo = (): SavedCustomerBookingInfo | null => {
  try {
    const stored = localStorage.getItem(CUSTOMER_INFO_KEY);
    return stored ? (JSON.parse(stored) as SavedCustomerBookingInfo) : null;
  } catch {
    return null;
  }
};

export const formatTimeToString = (timeString?: string | Date | null) => {
  if (!timeString) return "--:-- --";
  
  try {
    let date: Date;
    
    if (timeString instanceof Date) {
      date = timeString;
    } 
    else if (typeof timeString === 'string') {
      if (timeString.match(/^\d{1,2}:\d{2}(:\d{2})?(\s?(AM|PM))?$/i)) {
        const today = new Date();
        const parts = timeString.split(' ');
        const timePart = parts[0];
        const period = parts[1];
        
        const timeParts = timePart.split(':');
        const hours = parseInt(timeParts[0]);
        const minutes = parseInt(timeParts[1]);
        const seconds = timeParts[2] ? parseInt(timeParts[2]) : 0;
        
        let adjustedHours = hours;
        if (period) {
          if (period.toUpperCase() === 'PM' && hours !== 12) {
            adjustedHours = hours + 12;
          } else if (period.toUpperCase() === 'AM' && hours === 12) {
            adjustedHours = 0;
          }
        }
        
        date = new Date(today.getFullYear(), today.getMonth(), today.getDate(), adjustedHours, minutes, seconds);
      } 
      else {
        date = new Date(timeString);
      }
    } else {
      return "--:-- --";
    }
    
    if (isNaN(date.getTime())) {
      return "--:-- --";
    }
    
    return date
      .toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
      .toUpperCase();
  } catch (error) {
    return "--:-- --";
  }
};